import axios from 'axios';

const client = axios.create({ baseURL: process.env?.REACT_APP_AUTH0_API_ENV });

// Request interceptor
client.interceptors.request.use(
  (request) => {
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
const header = {
  headers: {
    'content-type': 'application/x-www-form-urlencoded'
  }
};
export const verifyEmailApi = async (payload) => {
  const params = new URLSearchParams();
  params.append('email', payload.email);
  params.append('captchaToken', payload.captcha);

  return await client.post(
    '/sm/api/user/email/send_verification_email',
    params,
    header
  );
};
export const getTenantDetail = async (payload) => {
  const path = new URL(payload?.redirectUri);
  const id = path.host.split('.')[0];

  return await axios.get(
    `${path.origin}/tenant/tenantId/${id}`,
    header
  );
};